export default __webpack_public_path__ + "static/media/ic_timeline_step_1.351b6022.svg";